/** TODO: Not functional yet, implement filtering logic */

import { SyncOutlined } from "@ant-design/icons";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@rumbledirect/ui";
import { Flex } from "antd";

export const ClaimKanbanFilters = () => {
  const queryClient = useQueryClient();
  return (
    <Flex align="center" justify="end" wrap>
      <Button
        onClick={() => queryClient.resetQueries()}
        icon={<SyncOutlined />}
      />
    </Flex>
  );
};
